/**
 * Platform Detection Utilities
 * Detects iOS vs Android for conditional camera implementations
 * Includes Capacitor native app detection
 */

import { Capacitor } from '@capacitor/core';

/**
 * Check if running as a native Capacitor app (iOS or Android)
 */
export const isNativeApp = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * Check if running as native iOS app (Capacitor)
 */
export const isNativeIOS = (): boolean => {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
};

/**
 * Check if running as native Android app (Capacitor)
 */
export const isNativeAndroid = (): boolean => {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
};

/**
 * Check if device is iOS (browser detection for PWA)
 */
export const isIOS = (): boolean => {
  const userAgent = window.navigator.userAgent.toLowerCase();

  // Standard iOS devices
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return true;
  }

  // iPadOS 13+ reports as Mac when requesting desktop site
  // Check for: Mac + touch support (only iPads have both)
  const isMacOS = /macintosh|mac os x/.test(userAgent);
  const hasTouchPoints = navigator.maxTouchPoints && navigator.maxTouchPoints > 1;

  return isMacOS && hasTouchPoints;
};

export const isAndroid = (): boolean => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /android/.test(userAgent);
};

export const isMobile = (): boolean => {
  return isIOS() || isAndroid();
};
